import React, { FC } from 'react';
import SVG from '@app/components/SVG';
import TrashIcon from '@app/images/trash-black.svg';
import PlusIcon from '@app/images/plus-primary.svg';
import {
  DataPointCell,
  DataPointContent,
  ExpandableCell,
  DataPointLabel,
  ExpandIcon,
  DataPointActions,
  IconButton,
} from '../NewVerificationTab.styles';

interface DataPointCellContentProps {
  label: React.ReactNode;
  isParentRow: boolean;
  isExpanded: boolean;
  expandable?: boolean;
  showDeleteIcon?: boolean;
  showAddIcon?: boolean;
  onToggleExpand: () => void;
  onDelete: () => void;
  onAdd: () => void;
}

export const DataPointCellContent: FC<DataPointCellContentProps> = ({
  label,
  isParentRow,
  isExpanded,
  expandable,
  showDeleteIcon,
  showAddIcon,
  onToggleExpand,
  onDelete,
  onAdd,
}) => (
  <DataPointCell>
    <DataPointContent>
      {expandable ? (
        <ExpandableCell>
          <DataPointLabel isParent={isParentRow}>{label}</DataPointLabel>
          <ExpandIcon onClick={onToggleExpand} expanded={isExpanded}>
            ▼
          </ExpandIcon>
        </ExpandableCell>
      ) : (
        <DataPointLabel isParent={isParentRow}>{label}</DataPointLabel>
      )}
    </DataPointContent>
    <DataPointActions>
      {showDeleteIcon && (
        <IconButton onClick={onDelete}>
          <SVG accessibilityLabel='Delete' image={TrashIcon} width={14} height={14} />
        </IconButton>
      )}
      {showAddIcon && (
        <IconButton onClick={onAdd}>
          <SVG accessibilityLabel='Add' image={PlusIcon} width={14} height={14} />
        </IconButton>
      )}
    </DataPointActions>
  </DataPointCell>
);
